var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container " }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("div", { staticClass: "col-md-8 text-left mb-3" }, [
            _c("h3", { staticClass: "Regular h0 widthFull" }, [
              _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
              _vm._v(" Modifica Documento: "),
              _c("b", [_vm._v(" " + _vm._s(_vm.doc.name) + " ")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
              _vm._v(
                "\n          In questa pagina puoi eliminare i documenti caricati e aggiungerne di nuovi.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-4 pt-4 center mb-3 text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-primary btnRed m-2 btn-sm ml-md-5",
                  attrs: {
                    to: { name: "loadDocuments", params: { item: _vm.item } }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "arrow-left", size: "1x" }
                  }),
                  _vm._v("\n          Indietro\n        ")
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "pb-5 pt-3 black widthFull vaillantCont",
            attrs: { id: "doc-form" }
          },
          [
            _c(
              "div",
              { staticClass: "row justify-content-center text-left pl-4 pr-4" },
              [
                _c("div", { staticClass: "col-md-8 center mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center text-left" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _vm._l(_vm.dbdoc.images, function(url, key, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-6 col-md-4 center mb-5"
                          },
                          [
                            _c("p", { staticClass: "pb-1 mb-1" }, [
                              _vm._v("File " + _vm._s(index + 1) + " ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "viewer",
                              {
                                ref: "viewer" + key,
                                refInFor: true,
                                staticClass: " clearfix widthFull",
                                on: { inited: _vm.inited }
                              },
                              [
                                _c("img", {
                                  key: key,
                                  staticClass: "img-fluid editImageCont",
                                  attrs: { src: url }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-xl mt-3",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.show(key)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "eye", size: "sm" }
                                }),
                                _vm._v(" Visualizza\n              ")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-xl  mt-3",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeDocument(
                                      _vm.docIndex,
                                      _vm.item.code,
                                      _vm.doc.name,
                                      _vm.doc.codice,
                                      key,
                                      index
                                    )
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "trash-alt", size: "sm" }
                                }),
                                _vm._v(" Elimina\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4 center mb-3 even" }, [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center text-left" },
                    [
                      _c("div", { staticClass: "col-md-12 center mb-3" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "front-image" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: false,
                                  size: 10240,
                                  ext: ["jpeg", "jpg", "png", "pdf"],
                                  mimes: [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/pdf"
                                  ]
                                },
                                expression:
                                  "{required:false,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                              }
                            ],
                            ref: "fileInput" + _vm.docIndex,
                            staticClass: "fileInput",
                            class: {
                              "is-invalid": _vm.errors.has("invoiceFront"),
                              valid: !!_vm.invoiceFront,
                              helper: !!_vm.invoiceFrontBucket
                            },
                            attrs: {
                              type: "file",
                              name: "invoiceFront",
                              id: "invoiceFront",
                              "data-vv-as": "Logo"
                            },
                            on: {
                              change: function($event) {
                                return _vm.uploadFile(
                                  _vm.docIndex,
                                  _vm.item.code,
                                  _vm.doc.name,
                                  _vm.doc.codice,
                                  _vm.dbdoc.completed
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel labelFileInput",
                              attrs: { for: "invoiceFront" }
                            },
                            [
                              !_vm.invoiceFrontName
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "smallText center white mt-3 mb-0 pb-0"
                                            },
                                            [
                                              _vm._v(
                                                "Scegli il Contratto quadro*"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c("span", {
                                    staticClass: "smallText center white",
                                    style: {
                                      backgroundImage:
                                        "url(" + _vm.invoiceFrontBucket + ")"
                                    }
                                  })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("invoiceFront")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.errors.first("invoiceFront")) +
                                    "\n                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dbdoc.percent
                            ? _c(
                                "div",
                                {
                                  staticClass: "progress mt-5",
                                  attrs: { id: "progFront" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar ",
                                      style: { width: _vm.dbdoc.percent + "%" },
                                      attrs: {
                                        id: "progress-bar-front",
                                        role: "progressbar",
                                        "aria-valuenow": "50",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.dbdoc.percent) +
                                          " %\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceFrontName
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                },
                                [_vm._v(_vm._s(_vm.invoiceFrontName))]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(2)
                    ]
                  )
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-3" }, [
      _c("h5", { staticClass: "Regular" }, [_c("b", [_vm._v("File caricati")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "Regular" }, [
      _c("b", [_vm._v("Carica nuovo File")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 center mt-5 mb-3" }, [
      _c("small", [
        _vm._v(
          "\n                Il documento può essere caricato nei formati jpeg, pdf, png, jpg (max 10MB)\n              "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4811f8f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4811f8f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editDocuments/index.vue
// module id = null
// module chunks = 